import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

const LANGUAGES = {
  en: 'English',
  fr: 'Français',
  zh: '中文',
  ar: 'العربية',
  ru: 'Русский',
  sw: 'Kiswahili'
};

const translations = {
  en: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    projects: 'Projects',
    investmentGuide: 'Investment Guide',
    companyFormation: 'Company Formation',
    news: 'News',
    contact: 'Contact',
    videos: 'Videos',
    businessAssistance: 'Business Assistance',
    welcomeMessage: 'The Best Choice For Your Successful Business!',
    welcomeSubtitle: 'Facilitate and support investors in the Democratic Republic of Congo',
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    contactUs: 'Contact Us',
    // Clear Messaging
    bridgingMarkets: 'Bridging Markets',
    clearMessagePart1: 'We help Dubai-based companies and investors successfully enter and navigate the high-potential, complex markets of Central Africa.',
    clearMessagePart2: 'We also assist African companies in establishing and scaling their operations in Dubai.',
    dubaiToAfrica: 'Dubai → Central Africa',
    africaToDubai: 'Africa → Dubai',
    // Strongest Sectors
    sectorsBadge: 'Our Strengths',
    sectorsTitle: 'Our Strongest Sectors',
    sectorsSubtitle: 'Six domains where we deliver proven expertise between the Gulf and Central Africa.',
    // About Page
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    ourMission: 'Our Mission',
    ourValues: 'Our Values',
    ourClients: 'Our Clients',
    missionText: 'As a local business consulting firm, First Business Group not only helps its clients understand Congolese business etiquette and culture, but also assists clients to establish strategic relations with government to ensure coordinated, timely government decision-making and approval.',
    governmentRelationsText: 'A strong government relations program remains an important factor for success in D.R. Congo, where, as in other emerging markets, the state uses its influence over market access and business rights to shape how far companies can go.',
    // Services
    ourServices: 'Our Services',
    needConsultation: 'Need a Consultation?',
    consultationText: 'Contact us to discuss your specific needs and discover how we can help you.',
    // Home page
    investmentOpportunities: 'Exceptional Investment Opportunities',
    investmentDesc: 'Discover exceptional opportunities in DRC with First Business Group SARLU: 70% of global cobalt reserves, vast copper and gold deposits, and immense growth potential. We transform these opportunities into success for our international clients.',
    whyInvestDRC: 'Why Invest in DRC?',
    whyInvestDesc: 'DRC offers exceptional opportunities with vast natural resources and immense growth potential.',
    readyToStart: 'Ready to Get Started?',
    readyToStartDesc: 'Contact us today to discover how we can help you succeed in DRC.',
    // Footer
    trustedPartner: 'Your trusted partner for investment in the Democratic Republic of Congo.',
    quickLinks: 'Quick Links',
    allRightsReserved: 'All rights reserved',
    // Contact
    contactInformation: 'Contact Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    sendMessage: 'Send us a Message',
    name: 'Name',
    company: 'Company',
    message: 'Message',
    yourName: 'Your name',
    yourEmail: 'your@email.com',
    yourCompany: 'Your company name',
    yourMessage: 'Your message...',
    sending: 'Sending...',
    send: 'Send Message',
    thankYou: 'Thank You!',
    messageReceived: 'We\'ve received your message and will respond soon.',
    businessHours: 'Business Hours',
    mondayFriday: 'Monday - Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed'
  },
  fr: {
    home: 'Accueil',
    about: 'À Propos',
    services: 'Services',
    projects: 'Projets',
    investmentGuide: 'Guide d\'Investissement',
    companyFormation: 'Création d\'Entreprise',
    news: 'Actualités',
    contact: 'Contact',
    videos: 'Vidéos',
    businessAssistance: 'Assistance Commerciale',
    welcomeMessage: 'Le Meilleur Choix Pour Votre Entreprise Prospère!',
    welcomeSubtitle: 'Faciliter et soutenir les investisseurs en République Démocratique du Congo',
    learnMore: 'En Savoir Plus',
    getStarted: 'Commencer',
    contactUs: 'Nous Contacter',
    // Clear Messaging
    bridgingMarkets: 'Connecter les Marchés',
    clearMessagePart1: 'Nous aidons les entreprises et investisseurs basés à Dubaï à entrer et naviguer avec succès dans les marchés complexes et à fort potentiel d\'Afrique Centrale.',
    clearMessagePart2: 'Nous accompagnons également les entreprises africaines dans leur établissement et leur expansion à Dubaï.',
    dubaiToAfrica: 'Dubaï → Afrique Centrale',
    africaToDubai: 'Afrique → Dubaï',
    // Strongest Sectors
    sectorsBadge: 'Nos Forces',
    sectorsTitle: 'Nos Secteurs les Plus Solides',
    sectorsSubtitle: 'Six domaines où nous livrons une expertise éprouvée entre le Golfe et l\'Afrique Centrale.',
    // About Page
    aboutUs: 'À Propos de Nous',
    ourStory: 'Notre Histoire',
    ourMission: 'Notre Mission',
    ourValues: 'Nos Valeurs',
    ourClients: 'Nos Clients',
    missionText: 'En tant que cabinet de conseil local, First Business Group aide non seulement ses clients à comprendre l\'étiquette et la culture des affaires congolaises, mais aide également les clients à établir des relations stratégiques avec le gouvernement pour assurer une prise de décision et une approbation gouvernementales coordonnées et opportunes.',
    governmentRelationsText: 'Un programme de relations gouvernementales solide reste un facteur important de succès en R.D. Congo, où, comme dans d\'autres marchés émergents, l\'État utilise son influence sur l\'accès au marché et les droits commerciaux pour façonner jusqu\'où les entreprises peuvent aller.',
    // Services
    ourServices: 'Nos Services',
    needConsultation: 'Besoin d\'une Consultation?',
    consultationText: 'Contactez-nous pour discuter de vos besoins spécifiques et découvrir comment nous pouvons vous aider.',
    // Home page
    investmentOpportunities: 'Opportunités d\'Investissement Exceptionnelles',
    investmentDesc: 'Découvrez les opportunités exceptionnelles en RDC avec First Business Group SARLU : 70% des réserves mondiales de cobalt, vastes gisements de cuivre et d\'or, et un potentiel de croissance immense. Nous transformons ces opportunités en succès pour nos clients internationaux.',
    whyInvestDRC: 'Pourquoi Investir en RDC?',
    whyInvestDesc: 'La RDC offre des opportunités exceptionnelles avec de vastes ressources naturelles et un potentiel de croissance immense.',
    readyToStart: 'Prêt à Commencer?',
    readyToStartDesc: 'Contactez-nous aujourd\'hui pour découvrir comment nous pouvons vous aider à réussir en RDC.',
    // Footer
    trustedPartner: 'Votre partenaire de confiance pour l\'investissement en République Démocratique du Congo.',
    quickLinks: 'Liens Rapides',
    allRightsReserved: 'Tous droits réservés',
    // Contact
    contactInformation: 'Informations de Contact',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'Email',
    sendMessage: 'Envoyez-nous un Message',
    name: 'Nom',
    company: 'Entreprise',
    message: 'Message',
    yourName: 'Votre nom',
    yourEmail: 'votre@email.com',
    yourCompany: 'Nom de votre entreprise',
    yourMessage: 'Votre message...',
    sending: 'Envoi...',
    send: 'Envoyer',
    thankYou: 'Merci!',
    messageReceived: 'Nous avons reçu votre message et nous vous répondrons bientôt.',
    businessHours: 'Heures d\'Ouverture',
    mondayFriday: 'Lundi - Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    closed: 'Fermé'
  },
  zh: {
    home: '首页',
    about: '关于我们',
    services: '服务',
    investmentGuide: '投资指南',
    companyFormation: '公司注册',
    news: '新闻',
    contact: '联系我们',
    videos: '视频',
    businessAssistance: '商务协助',
    welcomeMessage: '您成功业务的最佳选择！',
    welcomeSubtitle: '促进和支持刚果民主共和国的投资者',
    learnMore: '了解更多',
    getStarted: '开始',
    contactUs: '联系我们',
    aboutUs: '关于我们',
    ourStory: '我们的故事',
    ourMission: '我们的使命',
    ourValues: '我们的价值观',
    ourClients: '我们的客户',
    ourServices: '我们的服务',
    needConsultation: '需要咨询?',
    consultationText: '联系我们讨论您的具体需求。',
    investmentOpportunities: '卓越的投资机会',
    whyInvestDRC: '为什么投资刚果民主共和国?',
    readyToStart: '准备开始?',
    trustedPartner: '您在刚果民主共和国投资的可信赖合作伙伴。',
    quickLinks: '快速链接',
    allRightsReserved: '版权所有',
    contactInformation: '联系信息',
    address: '地址',
    phone: '电话',
    email: '电子邮件',
    sendMessage: '发送消息',
    name: '姓名',
    company: '公司',
    message: '消息',
    send: '发送',
    thankYou: '谢谢！',
    businessHours: '营业时间'
  },
  ar: {
    home: 'الرئيسية',
    about: 'عن الشركة',
    services: 'الخدمات',
    investmentGuide: 'دليل الاستثمار',
    companyFormation: 'تأسيس الشركات',
    news: 'الأخبار',
    contact: 'اتصل بنا',
    videos: 'فيديوهات',
    businessAssistance: 'المساعدة التجارية',
    welcomeMessage: 'الخيار الأفضل لنجاح أعمالك!',
    learnMore: 'اعرف المزيد',
    getStarted: 'ابدأ الآن',
    contactUs: 'اتصل بنا',
    aboutUs: 'عن الشركة',
    ourServices: 'خدماتنا',
    contactInformation: 'معلومات الاتصال',
    quickLinks: 'روابط سريعة'
  },
  ru: {
    home: 'Главная',
    about: 'О нас',
    services: 'Услуги',
    investmentGuide: 'Руководство по инвестициям',
    companyFormation: 'Регистрация компании',
    news: 'Новости',
    contact: 'Контакты',
    videos: 'Видео',
    businessAssistance: 'Бизнес-помощь',
    welcomeMessage: 'Лучший выбор для вашего успешного бизнеса!',
    learnMore: 'Узнать больше',
    getStarted: 'Начать',
    contactUs: 'Связаться с нами',
    aboutUs: 'О нас',
    ourServices: 'Наши услуги',
    contactInformation: 'Контактная информация',
    quickLinks: 'Быстрые ссылки'
  },
  sw: {
    home: 'Nyumbani',
    about: 'Kuhusu',
    services: 'Huduma',
    investmentGuide: 'Mwongozo wa Uwekezaji',
    companyFormation: 'Uundaji wa Kampuni',
    news: 'Habari',
    contact: 'Wasiliana',
    videos: 'Video',
    businessAssistance: 'Usaidizi wa Biashara',
    welcomeMessage: 'Chaguo Bora kwa Biashara Yako ya Mafanikio!',
    learnMore: 'Jifunze Zaidi',
    getStarted: 'Anza',
    contactUs: 'Wasiliana Nasi',
    aboutUs: 'Kuhusu Sisi',
    ourServices: 'Huduma Zetu',
    contactInformation: 'Maelezo ya Mawasiliano',
    quickLinks: 'Viungo vya Haraka'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [t, setT] = useState(translations.en);

  useEffect(() => {
    setT(translations[language] || translations.en);
  }, [language]);

  const value = {
    language,
    setLanguage,
    t,
    languages: LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};